import { HeaderNull } from '../../../../component/HeaderNull'
import { useState } from 'react'
import { NganHang } from './NganHang'
import { MangLuoi } from './MangLuoi'

function ThemTkRutTien () {
  const [tab, settab] = useState('ธนาคาร')
  const data = [
    {
      name: 'ธนาคาร'
    },
    {
      name: 'เครือข่าย'
    }
  ]

  return (
    <div>
      <HeaderNull title={'ตั้งค่าข้อมูลบัญชีธนาคาร'} link={'/usermobile'} />
      <div style={{ marginTop: '50px', padding: '10px' }}>
        <div className='ruttien_mobile_tab'>
          <div className='ruttien_mobile_tab_item'>
            <span>วิธีการฝากเงิน:</span>
            <div className='radio_ruttien_mobile'>
              {data.map((item, index) => (
                <button
                  className='radio_ruttien_mobile_btn'
                  key={index}
                  onClick={() => settab(item.name)}
                >
                  <i
                    className={`radio_ruttien_mobile_btn_icon ${
                      tab === item.name
                        ? 'radio_ruttien_mobile_btn_icon_active'
                        : ''
                    }`}
                  ></i>
                  {item.name}
                </button>
              ))}
            </div>
          </div>
        </div>

        {tab === 'ธนาคาร' && <NganHang />}
        {tab === 'เครือข่าย' && <MangLuoi />}
      </div>
    </div>
  )
}

export default ThemTkRutTien
